const accordionOpenEvent = new Event('accordionOpen', { bubbles: true });
const accordionCloseEvent = new Event('accordionClose', { bubbles: true });

const openAccordion = (accordion) => {

  // Open this accordion item
  const summaryEl = accordion.querySelector('summary')
  summaryEl.setAttribute('onclick', 'return false')
  accordion.classList.add('open')
  accordion.classList.remove('closed')

  // If it's part of a group, collapse any siblings
  const group = accordion?.dataset?.group;

  if( group ) {
    const thisGroup = document.querySelectorAll(`[data-group="${group}"]`);

    Array.from(thisGroup).forEach((groupAccordion) => {
      if( groupAccordion !== accordion ) {
        closeAccordion(groupAccordion);
      }
    })
  }

  accordion.dispatchEvent(accordionOpenEvent);
}

const closeAccordion = (accordion) => {
  accordion.classList.remove('open')
  accordion.classList.add('closed')

  // If the item is not animated, just close it immediately
  if( !accordion.hasAttribute('data-animate') ) {
    accordion.querySelector('summary').removeAttribute('onclick', 'return false')
    accordion.open = false;
  }

  accordion.dispatchEvent(accordionCloseEvent);
}

const setAccordionHeightVar = (accordion) => {
  // Start by calculating the inner heihgt of the accordion content and save as a css var for our animations to use
  const contentEl = accordion.querySelector('.js-accordion__content')
  const articleContentHeight = contentEl.offsetHeight

  accordion.style.setProperty(
    '--accordion-article-height',
    `${articleContentHeight}px`,
  )
}



const accordionGroups = document.getElementsByClassName('js-accordion__item')

if (!accordionGroups) return

Array.from(accordionGroups).forEach((accordion) => {

  // Set initial content height
  setAccordionHeightVar(accordion);

  // Manually apply an open and closed class that trigger keyframe animations
  accordion.addEventListener('click', (e) => {

    if (e.target.nodeName !== 'SUMMARY') {
      return;
    }
      
    // Recalc contents height
    setAccordionHeightVar(accordion);

    // When the accordion opens, prevent closing on next click
    if (!accordion.open) {
      openAccordion(accordion);
    }

    if (accordion.open) {
      closeAccordion(accordion);
    }
  })

  // If the accordion is animated we need to listen for the animation end event and then close it
  if( accordion.hasAttribute('data-animate') ) {

    accordion.addEventListener('animationend', (e) => {
      if (e.animationName === 'hideArticle') {
        accordion.open = false;

        accordion.querySelector('summary').removeAttribute('onclick', 'return false')
      }
    })

  }
})
